
import React, { forwardRef } from "react";

import Template from "./utils/Template";

export default forwardRef((props, ref) => (
  <Template ref={ref} tags={["none"]} {...props} >
    <path d="M19 5H5V8H19V5Z" fill="#CF3AA0" />
    <path
      d="M12 4H19C19.55 4 20 4.45 20 5V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V5C4 4.45 4.45 4 5 4H12Z"
      stroke="#CF3AA0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 4V2M17 4V2"
      stroke="#CF3AA0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 11H17"
      stroke="#CF3AA0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 15H14"
      stroke="#CF3AA0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Template>
));
